import { useDispatch } from "react-redux";
import { UPDATE_MODAL_ACTION_TYPE } from "../../../redux/actions-type";
import moment from "moment-timezone";
import { FaRegEdit } from "react-icons/fa";
import { IoMdMore } from "react-icons/io";

const UpdatesCard = ({ data, cellNumber }) => {
  const dispatch = useDispatch();

  const updateItem = (modalType) => {
    dispatch({
      type: UPDATE_MODAL_ACTION_TYPE.GET_UPDATES_MODAL,
      payload: {
        data: data,
        openModal: modalType !== "more" ? true : false,
      },
    });
  };

  const doubleClick = () => {
    updateItem("");
  };
  return (
    <tr className="class-table" onDoubleClick={doubleClick}>
      <td style={{ width: "200px" }}>
        <div className="td-con">
          <div className="table-scroll-text">
            {cellNumber}. {data?.sender.fullName}
          </div>
          <div className="right-fade"></div>
        </div>
      </td>
      {/* <td style={{ width: "200px" }}>
        <div className="td-con">
          <div className="table-scroll-text">
            {data?.recipient?.fullName || ""}
          </div>
          <div className="right-fade"></div>
        </div>
      </td> */}
      <td>
        <div className="td-con">
          <div className="table-scroll-text">
            {moment(data?.createdAt).tz("Asia/Baku").format("DD.MM.YYYY HH:mm")}
          </div>
        </div>
      </td>{" "}
      {/* <td>
        <div className="td-con">
          <div className="table-scroll-text">
            {data.status !== "pending" &&
              moment(data?.updatedAt)
                .tz("Asia/Baku")
                .format("DD.MM.YYYY HH:mm")}
          </div>
        </div>
      </td> */}
      <td
        style={
          data.action === "update"
            ? { backgroundColor: "#d2c3fe" }
            : { backgroundColor: "#ffced1" }
        }
      >
        <div className="td-con">
          <div className="table-scroll-text">
            {data.action === "update"
              ? "Yeniləndi"
              : data.action === "delete"
              ? "Silindi"
              : "Yaradıldı"}
          </div>
        </div>
      </td>
      {/* <td
        style={
          data.status === "pending"
            ? { backgroundColor: "#d2c3fe" }
            : data.status === "confirmed"
            ? { backgroundColor: "#d4ffbf" }
            : { backgroundColor: "#ffced1" }
        }
      >
        <div className="td-con">
          <div className="table-scroll-text">
            {data.status === "pending"
              ? "Gözləmədə"
              : data.status === "confirmed"
              ? "Təsdiqləndi"
              : data.status === "cancelled"
              ? "Ləğv edildi"
              : ""}
          </div>
        </div>
      </td> */}
      <td style={{ cursor: "pointer" }} onClick={updateItem}>
        <IoMdMore style={{ fontSize: "24px", color: "gray" }} />
      </td>
    </tr>
  );
};

export default UpdatesCard;
